import { Component, effect, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-home-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, SidebarComponent, LoadingBarModule],
  templateUrl: './home-layout.component.html',
})
export class HomeLayoutComponent {
  private router = inject(Router);
  actualUrl = signal(this.router.url);

  constructor() {
    effect(() => {});
    this.router.events.subscribe((value) => {
      if (value instanceof NavigationEnd) {
        this.actualUrl.set(this.router.url.toString());
      }
    });
  }

  get imInAuthRoute() {
    return this.actualUrl().includes('auth');
  }
}
